import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class AuthRequest extends Request {
    constructor() {
        super({
            req: RequestTypes.REFRESH_TOKEN,
            req_id: 0,
        });
    }
}

export default AuthRequest;